import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { JsxElement } from 'typescript';

const alertStyle = makeStyles((theme) => ({
  container: {
    width: '98%',
    height: '45px',
    font: theme.typography.body2.fontFamily,
    fontSize: '12px',
    marginTop: '15px',
    marginRight: 'auto',
    backgroundColor: theme.palette.error.main,
    color: theme.palette.primary.contrastText,
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  containerList: {
    width: '98%',
    font: theme.typography.body2.fontFamily,
    fontSize: '12px',
    marginTop: '15px',
    marginRight: 'auto',
    backgroundColor: theme.palette.error.main,
    color: theme.palette.primary.contrastText,
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'scroll',
    padding: '15px'
  },
  singleMessage: {
    display: 'inline-block',
    paddingRight: '15px'
  },
  listMessage: {
    display: 'inline-block',
    minHeight: '45px',
    maxHeight: '150px'
  },
  icon: {
    width: theme.spacing(1.3)
  }
}));

interface ErrorMessageBannerProps {
  message: string | JsxElement[];
}

const ErrorMessageBanner = ({ message }: ErrorMessageBannerProps) => {
  const classes = alertStyle();

  const boxStyle = Array.isArray(message) ? classes.containerList : classes.container;
  const msgStyle = Array.isArray(message) ? classes.listMessage : classes.singleMessage;

  return (
    <Box className={boxStyle}>
      <div className={msgStyle}>{message}</div>
    </Box>
  );
};

export default ErrorMessageBanner;
